import { IconWrapper } from '../runtime';
export default IconWrapper('cloud-sync', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M8.53809 8.14973L10.6919 10.1497L14.9996 6.14973M14.9077 10.6621C14.5386 12.2616 13.1055 13.4541 11.3939 13.4541L5.0303 13.4541C2.80443 13.4541 1 11.6496 1 9.42377C1 7.55369 2.27367 5.9811 4.00086 5.52613C4.24873 3.53798 5.9447 1.99951 8 1.99951C9.81515 1.99951 11.35 3.19946 11.8547 4.84937",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});